import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDownFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.00012 6L7.55568 9.55556L11.1112 6L4.00012 6Z",
		fill: "currentColor"
	})
});
export default SvgArrowDownFill;
